<template>
    <div data-testid="categories-filter">
        <h3>{{ $t('search.filters.f-cat.title') }}</h3>
        <div v-for="category in displayedCategories" :key="category.key">
            <VJoyCheckbox
                :checked="isChecked(category.key)"
                :data-testid="`categories-filter-${category.key}`"
                @update:checked="toggleFilter(category.key)"
            >
                {{ category.label }} ({{ category.count }})
            </VJoyCheckbox>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyCheckbox} from '@maltjoy/core-vue';
    import {useFiltersStore} from '../stores/filters.store';

    const filtersStore = useFiltersStore();
    const {availableSearchFilters} = storeToRefs(filtersStore);

    const DEFAULT_CATEGORY_LIMIT = 7;

    const displayedCategories = computed(() => availableSearchFilters.value?.categories.slice(0, DEFAULT_CATEGORY_LIMIT));

    function isChecked(categoryFilter: string) {
        return filtersStore.isFilterChecked('categories', categoryFilter);
    }

    function toggleFilter(categoryFilter: string) {
        filtersStore.toggleFilter('categories', categoryFilter);
    }
</script>
